import React from 'react';
import ReactDOM from 'react-dom';
import './style/global.scss';
import IndexComponent from './IndexComponent';

const rootNode = document.getElementById('root');

ReactDOM.render(<IndexComponent />, rootNode);